function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 55.078125 36.628906 C 55.078125 42.660156 57.871094 47.609375 61.378906 47.609375 C 64.800781 47.609375 67.589844 42.660156 67.589844 36.628906 C 67.589844 30.601562 64.800781 25.738281 61.378906 25.738281 C 57.871094 25.738281 55.078125 30.601562 55.078125 36.628906 Z M 34.378906 36.628906 C 34.378906 42.660156 31.589844 47.609375 28.171875 47.609375 C 24.660156 47.609375 21.871094 42.660156 21.871094 36.628906 C 21.871094 30.601562 24.660156 25.738281 28.171875 25.738281 C 31.589844 25.738281 34.378906 30.601562 34.378906 36.628906 Z M 66.871094 55.078125 C 68.039062 54.628906 69.210938 55.800781 68.761719 56.96875 C 66.871094 61.921875 61.109375 71.460938 45.539062 71.460938 C 28.621094 71.460938 23.039062 61.921875 21.238281 56.878906 C 20.789062 55.710938 21.960938 54.628906 23.128906 55.078125 L 23.21875 55.078125 C 37.261719 60.75 52.828125 60.75 66.871094 55.078125 Z M 45 86.488281 C 22.140625 86.488281 3.511719 67.859375 3.511719 45 C 3.511719 22.140625 22.140625 3.511719 45 3.511719 C 67.859375 3.511719 86.488281 22.140625 86.488281 45 C 86.488281 67.859375 67.859375 86.488281 45 86.488281 Z M 45 8.101562 C 24.660156 8.101562 8.101562 24.660156 8.101562 45 C 8.101562 65.339844 24.660156 81.898438 45 81.898438 C 65.339844 81.898438 81.898438 65.339844 81.898438 45 C 81.898438 24.660156 65.339844 8.101562 45 8.101562 Z M 45 8.101562 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileEmoji);
export default __webpack_public_path__ + "static/media/smile-emoji.a61fb145d19df64f7e3ced96ace604b5.svg";
export { ForwardRef as ReactComponent };